import React from "react";
import { ClipboardList, Landmark } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const PRODUCT_TYPES = ["عطور وبخور", "أزياء وعبايات", "مكياج وعناية بالبشرة", "قهوة ومشروبات", "مطاعم وحلويات",
  "إلكترونيات وجوالات", "عقار", "خدمات وتطبيقات", "صحة ولياقة", "منتجات منزلية", "سيارات", "تعليم ودورات", "أخرى"];

const FIELDS = [
  ["product_name", "اسم المنتج", "مثال: عطر EXACT"],
  ["benefit", "أهم ميزة", "مثال: ثبات 24 ساعة وفوحان فخم"],
  ["offer", "العرض أو السعر", "مثال: خصم 20% أو 199 ريال، أو: لا يوجد"],
  ["cta", "الدعوة للإجراء", "مثال: اطلبه الحين من المتجر"],
  ["setting", "المكان والأجواء", "مثال: مجلس فخم بإضاءة دافئة، أو: المخرج يختار"],
  ["contact", "الموقع / التواصل (اختياري)", "مثال: www.store.com أو فرع الرياض – طريق الملك فهد"],
];

const OPTIONAL = new Set(["contact"]);

/** معالم المملكة في خلفية الصور والفيديوهات: تلقائي = تنوّع بين كل المناطق، أو منطقة يحددها العميل */
export const LANDMARK_REGIONS = [["", "تلقائي — تنوّع معالم المملكة"], ["riyadh", "الرياض"], ["jeddah", "جدة"], ["alula", "العلا"], ["eastern", "المنطقة الشرقية"],
  ["aseer", "عسير وأبها"], ["tabuk", "تبوك ونيوم"], ["qassim", "القصيم وحائل"], ["taif", "الطائف"]];

export const EMPTY_BRIEF = { product_name: "", product_type: "", benefit: "", offer: "", cta: "", setting: "", contact: "", landmark: "" };

export const briefMissing = (b) => {
  const miss = [["product_type", "نوع المنتج"], ...FIELDS.filter(([k]) => !OPTIONAL.has(k)).map(([k, l]) => [k, l])].filter(([k]) => !(b?.[k] || "").trim());
  return miss.map(([, l]) => l);
};

/** Mandatory ad brief — the director builds the ad idea on it (plus the product photo analysis). */
export const AdBriefFields = ({ value, onChange, testId = "brief" }) => {
  const set = (k, v) => onChange({ ...value, [k]: v });
  return (
    <div className="rounded-xl border border-primary/30 bg-primary/5 p-4 space-y-3" data-testid={`${testId}-fields`}>
      <div>
        <div className="font-bold text-sm flex items-center gap-2"><ClipboardList className="w-4 h-4 text-primary" /> تفاصيل الإعلان <span className="text-[11px] text-destructive">(إلزامية)</span></div>
        <p className="text-[11px] text-muted-foreground mt-1 leading-relaxed">المخرج الذكي يبني فكرة الإعلان والمشاهد والكلام على هذه التفاصيل وعلى صورة منتجك، ويكمّلها بخبرته. تظهر الميزة كنصّ منبثق في الفيديو، ثم اسم العلامة والعرض والموقع في اللقطة الأخيرة.</p>
      </div>
      <div className="grid sm:grid-cols-2 gap-3">
        <div>
          <Label className="mb-1.5 block text-xs">نوع المنتج</Label>
          <Select value={value.product_type || undefined} onValueChange={(v) => set("product_type", v)}>
            <SelectTrigger className="bg-secondary border-border" data-testid={`${testId}-product_type`}><SelectValue placeholder="اختر النوع" /></SelectTrigger>
            <SelectContent className="bg-popover border-border">{PRODUCT_TYPES.map((t) => <SelectItem key={t} value={t}>{t}</SelectItem>)}</SelectContent>
          </Select>
        </div>
        {FIELDS.map(([k, label, ph]) => (
          <div key={k}>
            <Label className="mb-1.5 block text-xs">{label}</Label>
            <Input value={value[k] || ""} onChange={(e) => set(k, e.target.value)} placeholder={ph} maxLength={200}
              className="bg-secondary border-border" data-optional={OPTIONAL.has(k) ? "true" : undefined} data-testid={`${testId}-${k}`} />
          </div>
        ))}
      </div>
      <div data-testid={`${testId}-landmark-row`}>
        <Label className="mb-1.5 flex items-center gap-1 text-xs"><Landmark className="w-3.5 h-3.5 text-primary" /> معلم المملكة في الخلفية <span className="text-muted-foreground">(اختياري — يظهر في عمق المشهد ولا يغيّر مكانك)</span></Label>
        <div className="flex flex-wrap gap-1.5">
          {LANDMARK_REGIONS.map(([v, l]) => (
            <button key={v} type="button" onClick={() => set("landmark", v)} data-testid={`${testId}-landmark-${v || "auto"}`}
              className={`rounded-full px-3 py-1 text-xs border transition-colors ${(value.landmark || "") === v ? "bg-primary text-white border-primary" : "bg-secondary border-border text-muted-foreground hover:text-foreground"}`}>{l}</button>
          ))}
        </div>
      </div>
    </div>
  );
};
